import React, { useCallback } from 'react'

import Step from '../../../../../../features/components/Forms/StepForm/Step'
import Geolocations from '../../../../../ReusableFormFields/GeolocationsFields'

import { TIKTOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import {
  SHOW_COUNTRIES,
  SHOW_REGIONS,
  LOCATION_LIST
} from '../../../../../ReusableFormFields/GeolocationsFields/fields'

const stepFields = [SHOW_COUNTRIES, SHOW_REGIONS, LOCATION_LIST]

const GeolocationsStep = ({ formik, handleStepChange }) => {
  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  // show only countries with tiktok_id
  const countriesFilter = useCallback(country => country['tiktok_id'], [])

  return (
    <Step stepTitle={'Where would you like the ads to be shown?'} handleContinue={handleContinue}>
      <Geolocations
        formik={formik}
        countriesFilter={countriesFilter}
        showRegionsCountryFilter={false}
        showCustomLocations={false}
        showWorldwide={false}
        platform={TIKTOK_PLATFORM}
      />
    </Step>
  )
}

export default GeolocationsStep
